<template>
    <div class="automation-trigger-settings">
        <p>
            {{ t('automations-form-triggers_config-reward_used-description') }}
        </p>
        <div class="field">
            <label :class="{ label: true, 'label-danger': !isValid() }"
                >{{ t('automations-form-triggers_config-reward_used-reward_label') }}</label
            >
            <select
                class="form-control"
                v-model="places_rewards_id"
            >
                <option value="any" > {{ t('automations-form-triggers_config-reward_used-any_reward') }} </option>
                <option
                    v-for="reward in rewards"
                    :key="reward.id"
                    :value="reward.id"
                >
                    {{ reward.name || reward.description }}
                </option>
            </select>
        </div>
    </div>
</template>
<script>
import keviApi from "../../../keviApi";

export default {
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        return {
            rewards: [],
            places_rewards_id:
                this.value.length > 0 ? this.value[0].places_rewards_id : null,
        };
    },
    mounted: function () {
        this.loadRewards();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        loadRewards() {
            this.rewards = [];
            const options = keviApi.getOptions("rewards");
            this.$http(options).then((response) => {
                if (response.status === 200 && response.data.rewards.length) {
                    this.rewards = response.body.rewards;
                }
            });
        },
        changed: function () {
            this.$emit("input", [
                {
                    places_rewards_id: this.places_rewards_id,
                },
            ]);
        },
        isValid: function () {
            return !!this.places_rewards_id;
        },
    },
    watch: {
        value() {
            this.places_rewards_id =
                this.value.length > 0 ? this.value[0].places_rewards_id : null;
        },
        places_rewards_id(){
            this.changed();
        }
    },
};
</script>
